/* template
        "board": [
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
        ]

*/

export const MAPS = [
    {
        "name": "rocks in the forest",
        "board": [
            [1,1,1,0,0,0,0,0,1,1,1],
            [1,1,0,0,0,0,0,0,0,1,1],
            [1,0,0,0,0,0,0,0,0,0,1],
            [0,0,0,2,2,0,2,2,0,0,0],
            [0,0,0,2,0,0,0,2,0,0,0],
            [0,0,0,0,0,1,0,0,0,0,0],
            [0,0,0,2,0,0,0,2,0,0,0],
            [0,0,0,2,2,0,2,2,0,0,0],
            [1,0,0,0,0,0,0,0,0,0,1],
            [1,1,0,0,0,0,0,0,0,1,1],
            [1,1,1,0,0,0,0,0,1,1,1],
        ]
    },
    {
        "name": "the river",
        "board": [
            [0,0,1,0,0,0,0,0,0,0,2],
            [0,0,0,0,0,0,0,0,0,0,1],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [3,3,0,0,0,3,3,3,0,0,0],
            [3,3,0,3,3,3,3,3,0,3,0],
            [0,0,0,0,3,3,0,0,0,0,3],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,1,2,0,0,0,0,0,2,1,0],
            [0,0,0,0,0,0,0,0,0,0,0],
        ]
    },
    {
        "name": "the bay",
        "board": [
            [0,0,0,0,0,0,3,3,3,3,3],
            [1,0,0,0,0,0,0,3,3,3,3],
            [1,1,1,0,0,0,0,3,3,3,3],
            [2,2,1,0,0,0,0,3,3,3,3],
            [0,2,2,0,0,0,0,0,3,2,3],
            [0,0,0,0,0,0,0,0,3,3,3],
            [0,0,0,0,0,0,0,0,0,0,3],
            [0,0,0,0,0,0,0,0,0,2,2],
            [0,0,1,0,0,0,0,0,2,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
        ]
    }


]

